import React, {Component} from 'react';
import {APIClient} from "../../../utils/APIClient";
import {URLQueryStringParser} from "../../../utils/URLQueryStringParser";
import {API_URL} from '../../../settings/local_settings';
import {Loading} from "../../Loading";
import {withRouterParams} from "../../../utils/withRouterParams";
import { GOOGLE_CHANNEL } from '../../channels/channels';


class ConnectAdwordsAccount extends Component {
    constructor(props) {
        super(props);
        this.componentDidMount = this.componentDidMount.bind(this);
    }

    componentDidMount() {
        let code = new URLQueryStringParser().getUrlParams('code');
        let credential_label = localStorage.getItem('pending_credential_label');
        localStorage.removeItem('pending_credential_label');
        let pendingReconnectAdAccountId = localStorage.getItem('pending_reconnect_ad_account_id');
        localStorage.removeItem('pending_reconnect_ad_account_id');
        new APIClient(API_URL + 'get_access_tokens/google/').call('POST', {'code': code, 'credential_label': credential_label}).then((data) => {
            if (data && data.status === 'ERROR') {
                alert(data['error_message']);
                this.props.history.push('/agency');
            } else if (data && data.status === 'OK') {
                if (pendingReconnectAdAccountId) {
                    this.props.history.push('/agency/conections?just_connected=' + GOOGLE_CHANNEL + '&reconnect_ad_account_id=' + pendingReconnectAdAccountId);
                } else {
                    this.props.history.push('/agency/conections?just_connected='+GOOGLE_CHANNEL);
                }
                alert('La cuenta de Google Ads fue vinculada con éxito!')
            } else {
                alert('Hubo un error al conectar la cuenta. Por favor, intentá de nuevo.');
                this.props.history.push('/agency');
            }
        })
    }

    render() {
            return <Loading message="Por favor espere mientras se conecta su cuenta."/>
    }
}

export default withRouterParams(ConnectAdwordsAccount);
